import { createRoot } from 'react-dom/client'
import { Routes } from '@generouted/react-router'
import "./index.css"
import { installAxiosInterceptors } from './api/responseInterceptor'

installAxiosInterceptors()

createRoot(document.getElementById('root')!).render(
    <Routes />
)
